module.exports = __webpack_public_path__ + "img/V140.54bbc5ea.png";